"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropsFromRef = void 0;
const getFieldsFromRef = (ref) => {
    const fields = [];
    const elements = ref.current?.querySelectorAll('input,select,textarea');
    if (elements.length === 0) {
        fields.push(ref.current);
    }
    else {
        elements.forEach((element) => fields.push(element));
    }
    return fields;
};
const getPropsFromRef = (ref) => {
    const fields = getFieldsFromRef(ref);
    const attrs = {
        fields,
        value: fields[0]?.value,
        disabled: fields[0]?.disabled,
    };
    if (fields.length > 1) {
        const arrayValue = [];
        fields.forEach((field) => {
            attrs.disabled = field?.disabled || attrs.disabled;
            if (field.type !== 'checkbox') {
                arrayValue.push(field?.value);
            }
        });
        attrs.value = arrayValue.join('');
    }
    return attrs;
};
exports.getPropsFromRef = getPropsFromRef;
